<template>
    <div>
        <v-container fluid class="pt-0 pb-0 mb-5">
            <v-form
                    ref="queryForm"
            >
                <v-row align="center" justify="center" class="pl-12" style="background-color:#fff;">
                    <v-col
                            cols="3">
                        <Z-Source-Selector label="请选择医院"
                                           :source="'HospSelector'"
                                           v-model="query.hospId"></Z-Source-Selector>
                    </v-col>

                    <v-col
                            cols="3">
                        <v-text-field
                                label="请输入设备名称/采集位置"
                                prepend-inner-icon="search"
                                clearable
                                v-model="query.queryCondition"
                        ></v-text-field>
                    </v-col>
                    <v-col
                            cols="3">
                        <Z-Source-Selector label="数据类型"
                                           param="COLLECT_DATA_TYPE"
                                           source="DicSelector"
                                           v-model="query.collectDataType"></Z-Source-Selector>
                    </v-col>
                    <v-col
                            class="pt-0"

                            cols="2">
                        <v-btn color="primary"
                               :loading="loading.queryRequest"
                               @click="search">
                            搜索
                        </v-btn>
                        <v-btn
                                color="primary"
                                class="ma-2"
                                @click="resetQuery">
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>

        </v-container>

        <v-container fluid class="pa-12 pt-0 pb-0">
            <v-row align="start" no-gutter justify="center">
                <v-col
                        style="font-size:0.8rem;"
                        :sm="12"
                        :md="2"
                        :lg="2"
                        class="pt-0"
                        cols="2">
                    <v-row>
                        <v-col :sm="6"
                               :lg="12"
                               :md="12">
                            <v-row align="center"
                                   class="numCardItem"
                                   :style="{backgroundImage:'url('+'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/card4.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=101585294044&Signature=ZPCyc3uK8qE56EQFXGBTlYwAqEA%3D'+')'}">
                                <v-col
                                        cols="4">
                                    <img style="width:2rem;"
                                         src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/zongshu%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001585538934&Signature=XdHZoLqNCzR34ZuDidQ1%2FSS7Sd0%3D"
                                         alt="">
                                </v-col>
                                <v-col
                                        cols="4">
                                    监控对象
                                </v-col>
                                <v-col
                                        class="text-left"
                                        cols="4">
                                    {{numCardList.collectorCount}}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col :sm="6"
                               :lg="12"
                               :md="12">
                            <v-row align="center"
                                   class="numCardItem"
                                   :style="{backgroundImage:'url('+'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/card4.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=101585294044&Signature=ZPCyc3uK8qE56EQFXGBTlYwAqEA%3D'+')'}">
                                <v-col
                                        cols="4">
                                    <img style="width:2rem;"
                                         src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/zongshu%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001585538934&Signature=XdHZoLqNCzR34ZuDidQ1%2FSS7Sd0%3D"
                                         alt="">
                                </v-col>
                                <v-col
                                        cols="4">
                                    在线节点总数
                                </v-col>
                                <v-col
                                        class="text-left"
                                        cols="4">
                                    {{numCardList.onlineCount}}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col :sm="6"
                               :lg="12"
                               :md="12">
                            <v-row align="center"
                                   class="numCardItem"
                                   :style="{backgroundImage:'url('+'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/card3.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001585294285&Signature=J9lzjXNf3%2BUDWVyyiObTAwGoM4g%3D'+')'}">
                                <v-col
                                        cols="4">
                                    <img style="width:2rem;"
                                         src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/zhengchang%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001585538887&Signature=BO0ZlWIWdAMcFq2fpknY1MOLWj8%3D"
                                         alt="">
                                </v-col>
                                <v-col
                                        cols="4">
                                    正常节点
                                </v-col>
                                <v-col
                                        class="text-left"
                                        cols="4">
                                    {{numCardList.normalCount}}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col :sm="6"
                               :lg="12"
                               :md="12">
                            <v-row align="center"
                                   class="numCardItem"
                                   :style="{backgroundImage:'url('+'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/card2.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=101585294512&Signature=WaHJJydnva0nhk6nuH7mICvgi50%3D'+')'}">
                                <v-col
                                        cols="4">
                                    <img style="width:2rem;"
                                         src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/yujing%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001585538261&Signature=6DxQJuFu02EYjtp1sabx4k6XqxQ%3D"
                                         alt="">
                                </v-col>
                                <v-col
                                        cols="4">
                                    预警节点
                                </v-col>
                                <v-col
                                        class="text-left"
                                        cols="4">
                                    {{numCardList.warningCount}}
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                </v-col>
                <v-col
                        align-self="start"
                        class="pt-0"
                        :sm="12"
                        :md="10"
                        :lg="10"
                        cols="10"
                        id="listView">
                    <div class="pt-0 cardListView"
                         v-show="list.length>0"
                         v-infinite-scroll="loadMore"
                         infinite-scroll-disabled="busy"
                         infinite-scroll-distance="5"
                         :style="{height:listViewHeight+'px'}"
                         fluid>
                        <v-row>
                            <template
                                    v-for="(item,index) in list">
                                <v-hover v-slot:default="{ hover }">
                                    <v-col
                                            class="pt-0"
                                            xs="12"
                                            sm="6"
                                            md="4"
                                            lg="3"
                                            cols="3">
                                        <v-card
                                                style="height:100%;"
                                                :elevation="hover ? 12 : 2"
                                                :class="{ 'on-hover': hover }"
                                        >
                                            <div class="cardItem">

                                                <v-row v-if="!item.isWarning" align="center"
                                                       class="cardTitle cardTitle-normal no-gutters">
                                                    <div>
                                                        {{item.businessName}}
                                                    </div>
                                                </v-row>
                                                <v-row v-else align="center"
                                                       class="cardTitle cardTitle-warning no-gutters">
                                                    <div>
                                                        {{item.businessName}}
                                                    </div>
                                                </v-row>

                                                <div class="pl-4 pr-4 text-center">
                                                    <v-row>
                                                        <v-col cols="12">
                                                            <span>{{item.parentName}}</span>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="6" class="pt-0 pb-0">
                                                            <div class="cardItemTitle">{{item.sensorSeq}}#采集位置</div>
                                                            <!--<div v-if="!!item.collectPlace&&item.collectPlace.length<5"-->
                                                                 <!--style="max-width:100%"-->
                                                                 <!--class="d-inline-block">-->
                                                                <!--{{item.collectPlace}}-->
                                                            <!--</div>-->
                                                            <!--<v-tooltip-->
                                                                    <!--v-if="!!item.collectPlace&&item.collectPlace.length>=5"-->
                                                                    <!--top>-->
                                                            <v-tooltip
                                                                    top>
                                                                <template v-slot:activator="{ on }">
                                                                    <div style="max-width:100%" v-on="on"
                                                                         class="d-inline-block text-truncate">
                                                                        {{item.collectPlace}}
                                                                    </div>
                                                                </template>
                                                                <span>{{item.collectPlace}}</span>
                                                            </v-tooltip>

                                                        </v-col>
                                                        <v-col cols="6" class="pt-0 pb-0">
                                                            <div class="cardItemTitle">实时数据</div>
                                                            <div>
                                                                <span>
                                                                   {{item.collectValue}}
                                                                </span>
                                                                <!--<img v-if="true" style="width:1rem"-->
                                                                     <!--src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/jiantouup%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=100001585726562&Signature=AD%2FFZ7DoPltjAFxXVuAzCJ5pOKw%3D"/>-->
                                                                <!--<img v-else style="width:1rem"-->
                                                                     <!--src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/jiantoudown.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=100001585726668&Signature=9y4dlYccFzSXVp%2BmBqbTioE%2Fvv4%3D"/>-->
                                                            </div>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="6">
                                                            <div class="cardItemTitle">数据类型</div>
                                                            <div>{{item.collectDataType}}</div>
                                                        </v-col>
                                                        <v-col cols="6" v-if="item.isWarning">
                                                            <div class="cardItemTitle">预警开始时间</div>
                                                            <div>{{!item.stateStartTime?"":item.stateStartTime}}</div>
                                                        </v-col>
                                                        <v-col cols="6" v-if="!item.isWarning">
                                                            <!--<div class="cardItemTitle">上次预警解除时间</div>-->
                                                            <div class="cardItemTitle">最后上传时间</div>
                                                            <div>{{!item.createDateTime?"":item.createDateTime}}</div>
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </div>

                                        </v-card>
                                    </v-col>

                                </v-hover>

                            </template>

                        </v-row>
                        <div v-if="!hasMore" class="text-center">没有更多数据啦~</div>
                    </div>
                    <div
                            v-show="list.length<1">
                        <v-img
                                class="mb-4 mt-12"
                                height="15rem"
                                contain
                                src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/kong%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001585624749&Signature=Sxlt0P2qpif6dTbcFi%2FLrWViet8%3D"></v-img>
                    </div>
                </v-col>
            </v-row>
        </v-container>

        <z-loading v-model="loading.isLoading"></z-loading>

    </div>
</template>

<script>
  import ZSourceSelector from "@/components/ZSourceSelector"
  import infiniteScroll from 'vue-infinite-scroll'
  import ZLoading from "@/components/ZLoading"
  import {
    query,
    statusInfoQuery
  } from '@/api/EqpMonitor'

  export default {
    name: "EqpMonitor",
    data: () => ({
      query: {
        hospId: '',
        queryCondition: '',
        collectDataType:'',
        pagedQueryInfo: {
          pageSize: 10,
          index: 0,
          sum: 0
        }
      },
      loading: {
        queryRequest: false,
        isLoading:false
      },
      numCardList: {
        collectorCount: 0,
        onlineCount: 0,
        warningCount: 0,
        normalCount: 0,
      },
      list: [],
      listViewHeight: '',
      busy: false,
      hasMore: true,
      detailDialog: false,
      currentNode: ''
    }),
    components: {
      ZSourceSelector,
      ZLoading
    },
    watch: {},
    methods: {
      search() {
        this.loading.queryRequest = true;
        this.query.pagedQueryInfo.index = 1;
        this.queryList();
      },
      queryList() {
        query(this.query).then(res => {
          this.loading.queryRequest = false;
          if (this.query.pagedQueryInfo.index == 1) {
            this.list = [];
          }
          this.list = this.list.concat(res.list);
          this.query.pagedQueryInfo.sum = res.total;
          // 更新节点实时情况预览
          this.statusInfoQuery();
          if (this.query.pagedQueryInfo.sum <= this.list.length) {
            this.busy = true;
            this.hasMore = false;
          } else {
            this.busy = false;
            this.hasMore = true;
          }
        }).catch(err => {
          this.loading.queryRequest = false;
        })
      },
      resetQuery() {
        this.$refs.queryForm.reset();
        this.search();
      },
      // 查询监控节点总数
      statusInfoQuery() {
        statusInfoQuery({}).then(res => {
          this.numCardList = res;
        }).catch(err => {

        });
      },
      initListViewHeight() {
        var element = document.getElementById('listView');
        var actualTop = element.offsetTop;
        var current = element.offsetParent;
        while (current !== null) {
          actualTop += current.offsetTop;
          current = current.offsetParent;
        }
        var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        console.log(actualTop, '距离顶部的像素');
        console.log(height, '屏幕高');
        this.listViewHeight = height - actualTop - 30;
        console.log(this.listViewHeight, '容器高');
      },
      loadMore() {
        this.busy = true;
        this.query.pagedQueryInfo.index++;
        // alert(this.query.pagedQueryInfo.index + '当前页码');
        this.queryList();
      },
    },
    mounted() {
      window.onresize = () => {
        return (() => {
          var elem = document.getElementById("listView");
          if (!elem) {
          } else {
            this.initListViewHeight();
          }
        })();
      };
      this.initListViewHeight();
    },
    created(){
        console.log(this.$route.query,'query值绑定的对象');
        this.query.queryCondition=this.$route.query.name;
    }
  }
</script>

<style scoped>

    .numCardItem {
        width: 100%;
        height: 4.1rem;
        /*height: 6rem;*/
        background-color: #1E58BF;
        text-align: center;
        /*line-height: 100px;*/
        color: #fff;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        border-radius: 0.3em;
    }

    .cardItem {
        background-color: #fff;
        border-radius: 0.5rem;
        position: relative;
    }

    .cardItemTitle {
        font-size: 0.875rem;
        color: #666;
    }

    .cardTitle {
        border-top-left-radius: 0.5rem;
        border-top-right-radius: 0.5rem;
        /*font-size:0.8rem;*/
        color: #fff;
        padding: 0.5rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .cardTitle-warning {
        background-color: #FF6C00;
    }

    .cardTitle-normal {
        background-color: #1EBF76;
    }

    .cardTitle-off {
        background-color: #585F64;
    }

    .cardTitle-waiting {
        background-color: #fff;
    }

    .textIcon {
        padding: 0.3rem 0.5rem;
        background-color: #F1F1F1;
        margin-right: 0.5rem;
    }

    .talkIcon {
        width: 1.6rem;
        height: 1.5rem;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/tanchuang2%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001585295501&Signature=JuKWPjYZHDTAH0dc%2F3iN91bP9yc%3D");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
        cursor: pointer;
        float: right;
        margin-right: 1.5rem;
    }

    .talkIconActive {
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/tanchuang%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001585295781&Signature=ZNYKgDWOvO1SopgyFxHO1Jh19B4%3D");
    }

    .handle {
        width: 100%;
        height: 80%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        background-color: rgba(0, 0, 0, 0.8);
        border-radius: 0.5rem;
        color: #fff;
        user-select: none;
    }

    .handle::after {
        content: '';
        display: block;
        position: absolute;
        width: 0rem;
        height: 0rem;
        bottom: -1.6rem;
        right: 1.5rem;
        border: 0.8rem solid transparent;
        border-top-color: rgba(0, 0, 0, 0.8);
    }

    .cardListView {
        overflow-x: hidden;
        overflow-y: auto;
    }

    .cardListView::-webkit-scrollbar {
        width: 6px;
    }

    .cardListView::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
    }

    .cardListView::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
    }

    #listView {
        /*overflow-x: hidden;*/
        /*overflow-y: auto;*/
    }
</style>